import { KeyboardEventHandler } from "react";

import { TAB_INDEX_FOCUSABLE_ONLY } from "@multiweb/reactUtils";
import { OptionalTabIndex } from "@multiweb/types/react";

/**
 * Získá výsledný tab index na základě zadaných prop. Explicitně zadaný tabIndex má přednost. Pokud zadaný není,
 * je text zaměřitelný pouze pokud zpracovává události klávesnice (je zadaný alespoň jeden onKey* handler).
 * @param tabIndex Prop tabIndex zadaná explicitně do komponenty Text.
 * @param onKeyDown Handler pro zpracování událostí stisku kláves, který je zadaný do komponenty Text.
 * @param onKeyUp Handler pro zpracování událostí uvolnění kláves, který je zadaný do komponenty Text.
 * @param onKeyPress Handler pro zpracování událostí stisku a uvolnění kláves, který je zadaný do komponenty Text.
 */
export const getTabIndex = (
    tabIndex: OptionalTabIndex,
    onKeyDown?: KeyboardEventHandler,
    onKeyUp?: KeyboardEventHandler,
    onKeyPress?: KeyboardEventHandler,
): OptionalTabIndex => {
    if (tabIndex !== undefined) {
        return tabIndex;
    } else if (onKeyDown || onKeyUp || onKeyPress) {
        return TAB_INDEX_FOCUSABLE_ONLY;
    } else {
        return undefined;
    }
};

/**
 * Získá hodnotu pro atribut aria-label na základě zadaných props ariaLabelledBy, ariaLabel a title.
 * V případě zadané ariaLabelledBy vrací undefined. Další pořadí priorit je hodnota ariaLabel a nakonec title.
 *
 * @param ariaLabelledBy Id elementu sloužícího jako popisek.
 * @param ariaLabel Popisek textu.
 * @param title Vysvětlivka textu.
 */
export const getAriaLabel = (ariaLabelledBy?: string, ariaLabel?: string, title?: string): string | undefined => {
    if (ariaLabelledBy) {
        return undefined;
    } else if (ariaLabel) {
        return ariaLabel;
    } else {
        return title;
    }
};
